module.exports = __webpack_public_path__ + "ring-sample.png?57e45ceacb3c9294cb8da586c5a157e9";